import { useContext } from 'react';
import { Link } from 'react-navi';
import { MobileAppContext } from 'modules/mobileApp/context';

import androidAppSrc from 'assets/images/mobileApp/downloadAndroid.webp';
import { isIos } from 'helpers/common';
import { ImageComponent } from 'components/Image';

interface IDownloadAndroidAppProps {
  onClick?: () => void;
  width?: number;
  height?: number;
  download?: boolean;
}

export const DownloadAndroidApp = ({
  onClick,
  width,
  height,
  download,
}: IDownloadAndroidAppProps) => {
  const { data } = useContext(MobileAppContext);

  if (!data || !data.androidApk || isIos()) return null;

  const { androidApk } = data;

  return (
    <Link
      href={download ? androidApk.url : '/mobile-app'}
      className="button"
      onClick={onClick}
    >
      <ImageComponent
        src={androidAppSrc}
        width={width || 144}
        height={height || 48}
        alt="Google Play link"
        className="button-download"
      />
    </Link>
  );
};
